/**
 * Combined Entry Point
 *
 * Single entry that includes both the render API and Web Component.
 * Use this for a single script tag that provides all functionality.
 */

// Import and register web component (registers <bolder-widget> custom element)
// We must call the function to prevent tree-shaking
import { registerBolderWidget } from './web-component';
registerBolderWidget();

// Import widget entry (sets up window.BolderWidget)
import './widget-entry';

// Re-export for library consumers (if using as ES module)
export {
  renderBolderWidget,
  unmountBolderWidget,
  unmountAllBolderWidgets,
  getMountedWidgets,
} from './widget-entry';

// Re-export web component for library consumers
export { registerBolderWidget } from './web-component';
